import styled from 'styled-components';
import { black } from 'constants/colors';

export const recoverPasswordStyles = () => ({
  dialogActions: {
    display: 'block',
    justifyContent: 'center',
    padding: '0 2.4rem 3.0rem',
    margin: '1.0rem 0 0',
  },
  dialogContent: {
    padding: '0',
    width: '100%',
    maxWidth: '45.0rem',
  },
  dialogTitle: {
    fontWeight: 100,
    fontSize: '1.5rem',
    color: black,
  },
  dialogMainTitle: {
    fontSize: '2.4rem',
    padding: '0 2.4rem',
  },
  textField: {
    width: '100%',
  },
});

export const ForgetPasswordWrapper = styled.div`
  background-color: ${props => props.app.color1};
`;



// WEBPACK FOOTER //
// ./src/routes/ForgetPassword/components/styles.js